import { Container } from '@youhelp-ru/ui';
import { styled } from '@cp/ds';
import { DESKTOP_LAYOUT_WIDTH, Tokens, name } from './const';

export const Footer = styled(Container, { name, slot: 'footer' })(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  zIndex: 5,
  gap: theme.spacing(1),
  flexShrink: 0,
  backgroundColor: Tokens.colorPaper(),
  position: 'relative',
  paddingBlock: theme.spacing(1),
  borderTop: `1px solid ${Tokens.colorBorder()}`,
  maxWidth: 'stretch',
  [theme.breakpoints.up(DESKTOP_LAYOUT_WIDTH)]: {
    paddingBlock: theme.spacing(2.5),
  },
}));
